import { render, staticRenderFns } from "./ResendBoletoModal.vue?vue&type=template&id=6cb30bf8&"
import script from "./ResendBoletoModal.vue?vue&type=script&lang=js&"
export * from "./ResendBoletoModal.vue?vue&type=script&lang=js&"
import style0 from "./ResendBoletoModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports